module.exports = __webpack_public_path__ + "static/TownOfLight0-f6dc53f2946b38b6a0d460d5e3e59c70.webp";